import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Link from '@ux/link';
import { updateQuery, useTemporaryLogo } from '@ux/logo-hooks';
import goLogo from './goLogo.js';

/**
 * Renders shared GD logo.
 *
 * @param {Object} props Properties
 * @returns {React.ReactElement} shared logo
 * @public
 */
export default function GDLogo(props) {
  var defaultProps = _objectSpread({
    collapsedLogo: false,
    country: '',
    market: 'en-US',
    showCountryNameOnLogo: false,
    urlArgs: {}
  }, props);
  var tempLogo = useTemporaryLogo(defaultProps);
  // render an alternate logo if the timeframe applies
  if (tempLogo) return tempLogo;
  var logo = /*#__PURE__*/React.createElement(React.Fragment, null, defaultProps.market !== 'en-US' && defaultProps.showCountryNameOnLogo && /*#__PURE__*/React.createElement("span", {
    className: "topnav-country"
  }, defaultProps.country), /*#__PURE__*/React.createElement("figure", {
    style: {
      margin: 0
    },
    className: classnames('go-logo', defaultProps.figClass, !defaultProps.collapsedLogo ? 'go-logo--mobile' : 'go-logo--collapsed'),
    "aria-label": "GoDaddy"
  }, goLogo.mobile), !defaultProps.collapsedLogo && /*#__PURE__*/React.createElement("figure", {
    style: {
      margin: 0
    },
    className: classnames('go-logo go-logo--desktop', defaultProps.figClass),
    "aria-label": "GoDaddy"
  }, goLogo.desktop));
  return defaultProps.href ? /*#__PURE__*/React.createElement(Link, {
    className: defaultProps.className,
    urlArgs: defaultProps.urlArgs,
    "data-eid": defaultProps['data-eid'],
    onClick: defaultProps.onClick,
    href: updateQuery(defaultProps.href, defaultProps.urlArgs)
  }, logo) : logo;
}
GDLogo.propTypes = {
  /** CSS class name to apply to the outer element */
  'className': PropTypes.string,
  /** use the mobile logo at all breakpoints */
  'collapsedLogo': PropTypes.bool,
  /** Current country name. Required. */
  'country': PropTypes.string,
  /** Unique id used for Traffic 2 ie: 'your.product.godaddy.preformatted.eid_value.click' */
  'data-eid': PropTypes.string,
  /** href to pass to Link component */
  'href': PropTypes.string,
  /** Current market. */
  'market': PropTypes.string,
  /** Callback for a click on the logo link */
  'onClick': PropTypes.func,
  /** false in the US market and tablet and mobile, otherwise based on showCountryNameOnLogo in utility-bar */
  'showCountryNameOnLogo': PropTypes.bool,
  /** CSS class name to apply to wrapping `figure` element */
  'figClass': PropTypes.string,
  /** An object with specifications for a temporary alternate logo */
  'tempLogo': PropTypes.object,
  /** An object with arguments being passed to `Link` component to generate correct `href` */
  'urlArgs': PropTypes.object,
  /** An object with arguments being passed to `Link` component to generate correct `href` */
  'urls': PropTypes.shape({
    cdn: PropTypes.shape({
      href: PropTypes.string
    })
  })
};